import { createSelector } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import * as envelopeReducer from './envelope.reducer';

export const getState = (state: {
    envelope: envelopeReducer.State;
}): envelopeReducer.State => state.envelope;

export const getAllIsLoadingPage = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.isLoadingPage,
);
export const getAllHasLoadingPageError = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.hasLoadingPageError,
);
export const getAllIsUpdating = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.isUpdating,
);
export const getAllHasUpdatingError = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.hasUpdatingError,
);
export const getAllIsDeleting = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.isDeleting,
);
export const getAllHasDeletingError = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.hasDeletingError,
);
export const getAll = createSelector(
    getState,
    (state: envelopeReducer.State) => state.envelopes?.page,
);

export const getForEntityIdIsLoadingList = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.isLoadingList,
    );
export const getForEntityIdHasLoadingListError = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.hasLoadingListError,
    );
export const getForEntityIdIsUpdating = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.isUpdating,
    );
export const getForEntityIdHasUpdatingError = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.hasUpdatingError,
    );
export const getForEntityIdIsDeleting = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.isDeleting,
    );
export const getForEntityIdHasDeletingError = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]
                ?.hasDeletingError,
    );
export const getForEntityId = (props: {
    entityId: string;
    entity: SystemEntity;
}) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelopesForEntity[props.entity]?.[props.entityId]?.list,
    );

export const getForIdIsLoadingSingle = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelope[props.id]?.isLoadingSingle,
    );
export const getForIdHasLoadingSingleError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelope[props.id]?.hasLoadingSingleError,
    );
export const getForIdIsUpdating = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.envelope[props.id]?.isUpdating,
    );
export const getForIdHasUpdatingError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelope[props.id]?.hasUpdatingError,
    );
export const getForIdIsDeleting = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.envelope[props.id]?.isDeleting,
    );
export const getForIdHasDeletingError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.envelope[props.id]?.hasDeletingError,
    );
export const getForId = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.envelope[props.id]?.single,
    );

export const getDocumentsForIdIsLoadingList = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.documents[props.id]?.isLoadingList,
    );
export const getDocumentsForIdHasLoadingListError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.documents[props.id]?.hasLoadingListError,
    );
export const getDocumentsForIdIsUpdating = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.documents[props.id]?.isUpdating,
    );
export const getDocumentsForIdHasUpdatingError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.documents[props.id]?.hasUpdatingError,
    );
export const getDocumentsForIdIsDeleting = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.documents[props.id]?.isDeleting,
    );
export const getDocumentsForIdHasDeletingError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.documents[props.id]?.hasDeletingError,
    );
export const getDocumentsForId = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.documents[props.id]?.list,
    );

export const getSignatoriesForIdIsLoadingList = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.signatories[props.id]?.isLoadingList,
    );
export const getSignatoriesForIdHasLoadingListError = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) =>
            state.signatories[props.id]?.hasLoadingListError,
    );
export const getSignatoriesForId = (props: { id: string }) =>
    createSelector(
        getState,
        (state: envelopeReducer.State) => state.signatories[props.id]?.list,
    );

export const getActiveEnvelopeIsLoading = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.isLoadingSingle,
);
export const getActiveEnvelopeHasLoadingSingleError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.hasLoadingSingleError,
);
export const getActiveEnvelopeIsUpdating = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.isUpdating,
);
export const getActiveEnvelopeHasUpdatingError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.hasUpdatingError,
);
export const getActiveEnvelopeIsDeleting = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.isDeleting,
);
export const getActiveEnvelopeHasDeletingError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.hasDeletingError,
);
export const getActiveEnvelope = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.envelope[state.activeEnvelopeId]?.single,
);
export const getActiveEnvelopeId = createSelector(
    getState,
    (state: envelopeReducer.State) => state.activeEnvelopeId,
);

export const getDocumentsForActiveEnvelopeIsLoadingList = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.isLoadingList,
);
export const getDocumentsForActiveEnvelopeHasLoadingListError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.hasLoadingListError,
);
export const getDocumentsForActiveEnvelopeIsUpdating = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.isUpdating,
);
export const getDocumentsForActiveEnvelopeHasUpdatingError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.hasUpdatingError,
);
export const getDocumentsForActiveEnvelopeIsDeleting = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.isDeleting,
);
export const getDocumentsForActiveEnvelopeHasDeletingError = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.hasDeletingError,
);
export const getDocumentsForActiveEnvelope = createSelector(
    getState,
    (state: envelopeReducer.State) =>
        state.documents[state.activeEnvelopeId]?.list,
);
